import { render, staticRenderFns } from "./LinkInput.vue?vue&type=template&id=47ae2ec5&scoped=true&"
import script from "./LinkInput.vue?vue&type=script&lang=js&"
export * from "./LinkInput.vue?vue&type=script&lang=js&"
import style0 from "./LinkInput.vue?vue&type=style&index=0&id=47ae2ec5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ae2ec5",
  null
  
)

export default component.exports